import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const showPermissionClassificationRequest = (id, { dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', `/permission_classifications/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const indexPermissionClassificationsRequest = ({
  dispatch,
  format,
  params = {},
  failureCallback,
  successCallback
}) => {
  let formatt = '';
  if (format) {
    formatt = `.${format}`;
  }
  ApiService.request('get', `/permission_classifications${formatt}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });
};

export const createPermissionClassificationRequest = ({
  dispatch,
  params,
  formData,
  callback,
  failureCallback,
  successCallback
}) => {
  ApiService.request('post', '/permission_classifications', {
    dispatch,
    params,
    formData,
    callback,
    failureCallback,
    successCallback
  });
};

export const updatePermissionClassificationRequest = (
  id,
  { dispatch, params, formData, failureCallback, successCallback }
) =>
  ApiService.request('put', `/permission_classifications/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const deletePermissionClassificationRequest = ({
  dispatch,
  params,
  failureCallback,
  successCallback,
  callback
}) =>
  ApiService.request('delete', '/permission_classifications/massive_destroy', {
    dispatch,
    params,
    formData: false,
    failureCallback,
    successCallback,
    callback
  });

export const exportPermissionClassificationsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) => {
  ApiService.request('get', `/permission_classifications/export.xlsx`, {
    dispatch,
    params,
    failureCallback,
    responseType: 'text',
    successCallback
  });
};

export const preImportPermissionClassificationRequest = ({
  dispatch,
  params,
  formData,
  failureCallback,
  successCallback
}) => {
  ApiService.request('get', '/permission_classifications/pre_import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importPermissionClassificationRequest = ({
  dispatch,
  params,
  formData,
  failureCallback,
  successCallback
}) => {
  ApiService.request('post', '/permission_classifications/import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importTemplatePermissionClassificationRequest = ({
  dispatch,
  params,
  failureCallback,
  successCallback
}) => {
  ApiService.request('get', '/permission_classifications/import_template', {
    dispatch,
    params,
    failureCallback,
    responseType: 'text',
    successCallback
  });
};

export const activePermissionClassificationRequest = ({
  dispatch,
  params,
  failureCallback,
  successCallback,
  callback
}) =>
  ApiService.request('post', '/permission_classifications/massive_active', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback
  });

export const deactivatePermissionClassificationRequest = ({
  dispatch,
  params,
  failureCallback,
  successCallback,
  callback
}) =>
  ApiService.request('post', '/permission_classifications/massive_deactivate', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback
  });

export const debounceIndexPermissionClassificationsRequest = AwesomeDebouncePromise(
  indexPermissionClassificationsRequest,
  300
);
